import { IconX } from "@tabler/icons-react";
import { Badge, Button, Card, Group, Stack, Text } from "@/components/ui";
import type { Area, OrganizacionAdmin, UsuarioAdmin } from "@/lib/types";
import { PanelEdicionUsuario } from "./PanelEdicionUsuario";

/**
 * Card de usuario para mobile · resumen + toggle de edición. Cuando
 * está expandida muestra el panel de edición completo (las 3 sub-
 * cards se apilan verticalmente en mobile).
 */
export function UsuarioMobileCard({
  u,
  expandida,
  onToggle,
  todasAreas,
  todasOrganizaciones,
}: {
  u: UsuarioAdmin;
  expandida: boolean;
  onToggle: () => void;
  todasAreas: Area[];
  todasOrganizaciones: OrganizacionAdmin[];
}) {
  return (
    <Card padding="md">
      <Stack gap="xs">
        <Group justify="space-between" align="flex-start" className="flex-nowrap">
          <div className="min-w-0 flex-1">
            <Text size="xs" className="truncate font-mono">
              {u.email}
            </Text>
            {u.fullName ? (
              <Text size="xs" c="dimmed">
                {u.fullName}
              </Text>
            ) : null}
          </div>
          <Button
            variant={expandida ? "filled" : "default"}
            size="xs"
            onClick={onToggle}
            leftSection={expandida ? <IconX size={12} /> : undefined}
          >
            {expandida ? "Cerrar" : "Editar"}
          </Button>
        </Group>

        <Stack gap={4}>
          <Linea label="Roles:" items={u.roles} color="info" />
          <Linea label="Áreas:" items={u.areas} variant="outline" />
          <Linea
            label="Organizaciones:"
            items={u.organizaciones.map((o) => o.nombre)}
            color="exito"
            placeholderVacio="Todas (admin/auditor)"
          />
        </Stack>

        {expandida ? (
          <div className="border-t border-border pt-3">
            <PanelEdicionUsuario u={u} todasAreas={todasAreas} todasOrganizaciones={todasOrganizaciones} />
          </div>
        ) : null}
      </Stack>
    </Card>
  );
}

function Linea({
  label,
  items,
  color,
  variant = "light",
  placeholderVacio = "—",
}: {
  label: string;
  items: string[];
  color?: string;
  variant?: "light" | "outline";
  placeholderVacio?: string;
}) {
  return (
    <Group gap={6} className="flex-wrap">
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      {items.length === 0 ? (
        <Text size="xs" c="dimmed">
          {placeholderVacio}
        </Text>
      ) : (
        items.map((x) => (
          <Badge key={x} variant={variant} color={color} size="sm" uppercase={false}>
            {x}
          </Badge>
        ))
      )}
    </Group>
  );
}
